import Glide from "@glidejs/glide";

const createSlideshow = (slideshow) => {
  const slides = slideshow.dataset.slidesPerView || 1;
  const bound = slideshow.dataset.bound || false;
  var autoplay;
  if(slideshow.dataset.autoplay) {
    autoplay = slideshow.dataset.autoplay
  } else {
    autoplay = window.innerWidth < 600 ? 5000 : 6000;
  }
  const breakpoints =
  slides >= 2 ? { 9999: { perView: slides }, 1440: { perView: 2 }, 900: { perView: 1 } } : {};

  var perTouch = slides;
  let mobileFirstBreakpoints = Object.entries(breakpoints).reverse()
  Object.entries(mobileFirstBreakpoints).forEach(el => {
    if(window.innerWidth < el[1][0]) {
      perTouch = el[1][1].perView
    }
  });

  const glide = new Glide(slideshow, {
    type: slideshow.dataset.slideshowType || "carousel",
    perView: slides,
    gap: slideshow.dataset.slideshowGap || 0,
    breakpoints,
    bound,
    perTouch,
    autoplay,
  }).mount();

  glide.on('run', function() {
    if(slideshow.querySelectorAll('.glide__bullet').length > 0) {
      slideshow.querySelectorAll('.glide__bullet').forEach((el) => {
        el.classList.remove('glide__bullet--active')
      })
      let bullet = slideshow.querySelector(`.glide__bullet[data-glide-dir="=${glide.index}"]`)
      if(bullet) {
        bullet.classList.add('glide__bullet--active')
      }
    }
  })

  slideshow.dataset.perTouch = perTouch
  let totalSlides = glide._c.Html.slides.length / perTouch || []
  let bullets = '';
  for (let index = 0; index < totalSlides; index++) {
    let activeClass = (index === 0) ? 'glide__bullet--active' : '';
    bullets += `<button class="glide__bullet ${activeClass}" data-glide-dir="=${index * perTouch}" aria-label="Visualizza la diapositiva ${index * perTouch + 1}"></button>`;
  }
  if(slideshow.querySelector('.glide__bullet')) {
    slideshow.querySelector('.glide__bullets').innerHTML = bullets
  }

  slideshow.querySelectorAll("[data-slide-prev]").forEach((e) =>
    e.addEventListener("click", () => {
      /* slideshow.querySelectorAll('.glide__bullet').forEach((el) => {
        el.classList.remove('glide__bullet--active')
      })
      let bullet = slideshow.querySelector(`.glide__bullet[data-glide-dir="=${amount}"]`)
      if(bullet) {
        bullet.classList.add('glide__bullet--active')
      } */
      glide.go("<");
    })
  );

  slideshow.querySelectorAll("[data-slide-next]").forEach((e) =>
    e.addEventListener("click", () => {
      glide.go(">");
      /* slideshow.querySelectorAll('.glide__bullet').forEach((el) => {
        el.classList.remove('glide__bullet--active')
      })
      let bullet = slideshow.querySelector(`.glide__bullet[data-glide-dir="=${amount}"]`)
      if(bullet) {
        bullet.classList.add('glide__bullet--active')
      } */
    })
  );
};

export default () => {
  const slideshows = document.querySelectorAll(".glide");
  slideshows.forEach(createSlideshow);
};



// WEBPACK FOOTER //
// ./scripts/steroids/slideshow.js